import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { criteria } from "@/data/content";
import { Reveal, SectionLabel, EASE } from "./Reveal";

const Row = ({ c, i, open, onToggle }) => (
  <div className="border-b border-[#C9D9EA]" data-testid={`criteria-item-${i}`}>
    <button onClick={onToggle} className="group flex w-full items-start gap-5 py-7 text-left sm:gap-10" data-testid={`criteria-toggle-${i}`} aria-expanded={open}>
      <span className="w-10 shrink-0 pt-1 text-sm font-bold tracking-widest text-[#09549F]">0{i + 1}</span>
      <span className={`flex-1 text-xl font-bold leading-snug transition-colors sm:text-2xl lg:text-3xl ${open ? "text-[#005EB8]" : "text-[#05325F] group-hover:text-[#005EB8]"}`}>{c.title}</span>
      <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.4, ease: EASE }}
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 ${open ? "border-[#005EB8] bg-[#005EB8] text-white" : "border-[#05325F] text-[#05325F]"}`}>
        <Plus className="h-5 w-5" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.5, ease: EASE }} className="overflow-hidden">
          <div className="pb-8 pl-[3.75rem] pr-4 sm:pl-[5rem]">
            <p className="max-w-2xl text-base leading-relaxed text-[#4A607A]">{c.evidence}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {c.tags.map((t) => <span key={t} className="rounded-full bg-white px-3 py-1 text-xs font-bold text-[#09549F]">{t}</span>)}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const Criteria = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="criteria" className="bg-[#F0F5FA] py-24 md:py-32" data-testid="criteria-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <SectionLabel index="03">Role fit</SectionLabel>
            <h2 className="text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-[#05325F] sm:text-5xl">What the role asks. What I bring.</h2>
            <p className="mt-6 text-base leading-relaxed text-[#4A607A]">As Senior Project Officer, I will bring the following assets and skills:</p>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="border-t border-[#C9D9EA] lg:col-span-8">
          {criteria.map((c, i) => <Row key={c.title} c={c} i={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />)}
        </Reveal>
      </div>
    </section>
  );
};
